import React from "react";
import { Stack, TextField, InputLabel } from "@mui/material";


export default function InputField({ label, type, onChange }) {
  return (
    <Stack spacing={1}>
      <InputLabel>{label}</InputLabel>

      <TextField
        placeholder={label}
        type={type}
        onChange={(event) => onChange(event)}

      />
    </Stack>
  )
}
